import React from 'react';
import { FiTrendingUp, FiZap, FiMessageCircle, FiStar, FiX } from 'react-icons/fi';
import { formatDate } from '../utils/dates';

const TYPE_CONFIG = {
  CORRELATION: { icon: FiZap, label: 'Correlation' },
  TREND: { icon: FiTrendingUp, label: 'Trend' },
  SUGGESTION: { icon: FiMessageCircle, label: 'Suggestion' },
  SUMMARY: { icon: FiStar, label: 'Summary' },
};

const CONFIDENCE_BADGE = {
  LOW: 'bg-white/10 text-white/50',
  MEDIUM: 'bg-white/15 text-white/70',
  HIGH: 'bg-white/20 text-white/90',
};

export default function InsightCard({ insight, onDismiss }) {
  const config = TYPE_CONFIG[insight.insightType] || TYPE_CONFIG.SUMMARY;
  const Icon = config.icon;

  return (
    <div className="glass rounded-xl p-5 relative">
      <button
        onClick={() => onDismiss(insight.id)}
        className="absolute top-3 right-3 text-white/40 hover:text-white"
        title="Dismiss"
      >
        <FiX size={16} />
      </button>

      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-white/10 text-white/70">
          <Icon size={18} />
        </div>
        <div className="flex-1 pr-6">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold uppercase tracking-wide text-white/50">
              {config.label}
            </span>
            {insight.confidence && (
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${CONFIDENCE_BADGE[insight.confidence]}`}>
                {insight.confidence.toLowerCase()} confidence
              </span>
            )}
          </div>
          <h3 className="font-semibold text-white">{insight.title}</h3>
          <p className="text-sm text-white/70 mt-1 leading-relaxed">{insight.body}</p>
          {insight.dataWindowStart && (
            <p className="text-xs text-white/40 mt-2">
              Based on data from {formatDate(insight.dataWindowStart)} to {formatDate(insight.dataWindowEnd)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
